import type { TimeOfDay } from 'generated/openapi';
import { type HTMLAttributes, memo } from 'react';

import { PlayTimeGrid } from '@/shared/components/playTimeGrid';
import { Card } from '@/shared/components/ui/card';

export interface ProfileDetailsVibePlayTimeProps extends HTMLAttributes<HTMLDivElement> {
  playSchedule: Record<string, TimeOfDay[]> | undefined;
}

export const ProfileDetailsVibePlayTime = memo(
  function ProfileDetailsVibePlayTime(props: ProfileDetailsVibePlayTimeProps) {
    const { playSchedule, ...rest } = props;

    return (
      <Card variant="data" {...rest}>
        <p className="text-sm leading-5 font-bold">Play time</p>
        <PlayTimeGrid data={playSchedule} />
      </Card>
    );
  },
);
